import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { assignOrderToDriver } from "../../actions/mmActions";
import { showAlertSnackbar } from '../../reducers/uiSlice';
import UniDialog from "../Common/UniDialog";
import Alert from '@material-ui/lab/Alert';
import Snackbar from '@material-ui/core/Snackbar';
import { makeStyles, TextField } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { getUserPreference, handleTextualizeDriverNameAndVehicleType } from "../../utilities/common";

const useStyles = makeStyles((theme) => ({
    container: {
        display: 'flex', 
        flexDirection: 'column', 
        height: 750
    },
    formControl: {
        marginLeft: theme.spacing(2),
        minWidth: 180,
        },
}));

function TransferToDrivers(props) {
    const classes = useStyles();
    const {t} = useTranslation('secondDelivery');
    const dispatch = useDispatch();

    const quickTransfer = useSelector(state => state.quickTransfer)

    const userPref = getUserPreference();

    const [transferToId, setTransferToId] = useState('');
    const [transferDriverName, setTransferDriverName] = useState('...');
    const [driverExist, setDriverExist] = useState(false);
    const [selectedOrders, setSelectedOrders] = useState([]);

    useEffect(() => {
        if(props.selectedOrders) {
            setSelectedOrders(props.selectedOrders);
        } else {
            setSelectedOrders([]);
        }
    }, [props.selectedOrders])

    return (
        <>
            <UniDialog
                title={t('dialog:transfer_orders_title')}
                message={t('dialog:transfer_orders_message')}
                open={props.openTransferDriver}
                onClose={()=> {
                    props.handleDriverTransferClose();
                    setTransferToId('');
                    setTransferDriverName('...');
                }}
                onFinish={handleTransferOrder}
                buttonDisabled={!transferToId || !transferDriverName || transferDriverName === '...'}
            >
                <div className={classes.driverStyle}>
                    <div style={{ marginBottom: 10 }}>
                        <span style={{ marginLeft: 10 }}>{transferDriverName}</span>
                    </div>
                    <TextField
                        autoFocus
                        label="Driver ID"
                        fullWidth
                        onChange={(e) => {
                            setTransferDriverName(handleTextualizeDriverNameAndVehicleType(e.target.value, userPref.userCity, false, quickTransfer.getLetianStaff));
                            setTransferToId(e.target.value);
                        }}
                        error={transferToId.length <= 0}
                    />
                </div>
            </UniDialog>
        </>
    )

    function handleTransferOrder(){
        if (selectedOrders.length <= 0){
            dispatch(showAlertSnackbar({title: "Please select orders for transfer"}))
            return
        }

        let paramsAssign = {
            orders: selectedOrders,
            to_driver: transferToId,
            from_driver: null,
            operator: userPref.username
        }    
        dispatch(assignOrderToDriver(paramsAssign))
        .then(() => {
            dispatch(showAlertSnackbar({message: t('transfer_success_message'), type: 'success'}))
        })
        .catch(() => {
            dispatch(showAlertSnackbar({message: t('transfer_fail_message'), type: 'error'}))
        })
    }
}

export default TransferToDrivers;